import { render } from "./CustomInputSelect.vue?vue&type=template&id=07dcd55c"
import script from "./CustomInputSelect.vue?vue&type=script&lang=js"
export * from "./CustomInputSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__